<div class="content">
  <div class="auth-form">
    <div class="auth-form_svg">
      <stxt-svg-icon
        class="close_svg"
        (click)="closeModal()"
        (keydown.enter)="closeModal()"
        tabindex="0"
        [iconConfig]="closeSvg"
      ></stxt-svg-icon>
    </div>
    <div class="auth-form_content">
      <form [formGroup]="authForm" (keydown.enter)="onEnterKeyPress($event)" tabindex="-1">
        <div *ngIf="!isSignUp" class="auth-form_header">
          <img src="/assets/icons/stxt_favicon_d2c_auth.svg" alt="welcome-image" />
          <div class="auth-form_header__title">
            <p class="title-primary">LOG IN</p>
            <p class="title-secondary">TO JustSext</p>
          </div>
          <p class="auth-form_subheading">Welcome back! Log in to continue.</p>
        </div>
        <div *ngIf="isSignUp" class="auth-form_header">
          <img src="/assets/icons/stxt_favicon_d2c_auth.svg" alt="welcome-image" />
          <div class="auth-form_header__title">
            <p class="title-primary">SIGN UP</p>
            <p class="title-secondary">TO CONTINUE</p>
          </div>
          <p class="auth-form_subheading">Create your JustSext account to get started.</p>
        </div>
        <ng-container>
          <stxt-input
            [inputConfig]="emailInput"
            [disabled]="isAnyAuthInProgress()"
            formControlName="email"
            class="auth-input"
          ></stxt-input>
          <stxt-input
            [inputConfig]="passwordInput"
            [disabled]="isAnyAuthInProgress()"
            formControlName="password"
            class="auth-input"
          ></stxt-input>
          <stxt-button
            class="auth_btn auth_toggle__btn"
            ngbAutofocus
            (click)="executeRecaptcha()"
            [disabled]="!authForm.valid || isAnyAuthInProgress()"
            [buttonConfig]="isSignUp ? signUpButton : loginButton"
          >
            {{ isSignUp ? signUpButton.text : loginButton.text }}
          </stxt-button>
          <div class="divider">
            <p class="divider_text">or</p>
          </div>
          <stxt-button
            class="auth_btn__google"
            (click)="handleGoogleSignIn()"
            [buttonConfig]="googleButton"
            [disabled]="isAnyAuthInProgress()"
          >
            <div class="auth-form_google flex items-center">
              <stxt-svg-icon [iconConfig]="googleSvg"></stxt-svg-icon>
              <p>{{ googleButton.text }}</p>
            </div>
          </stxt-button>
        </ng-container>
        <p class="auth-form_terms">
          By proceeding, you agree to our
          <button (click)="openTOS()" (keydown.enter)="openTOS()" tabindex="0">Terms of Use</button>
          and
          <button (click)="openPrivacyPolicy()" (keydown.enter)="openPrivacyPolicy()" tabindex="0">
            Privacy Policy
          </button>
          and confirm that you're 18 years old. This site is protected by reCAPTCHA and the Google
          <button
            (click)="openGPrivacyPolicy()"
            (keydown.enter)="openGPrivacyPolicy()"
            tabindex="0"
          >
            Privacy Policy
          </button>
          and
          <button (click)="openGTOS()" (keydown.enter)="openGTOS()" tabindex="0">
            Terms of Service
          </button>
          apply.
        </p>

        <div class="auth-form_footer">
          <p>
            {{ !isSignUp ? 'Need an account?' : 'Already have an account?' }}
            <button
              (click)="toggleAuthType()"
              (keydown.enter)="toggleAuthType()"
              tabindex="0"
              [disabled]="isAnyAuthInProgress()"
            >
              {{ !isSignUp ? 'Sign up' : 'Log in' }}
            </button>
          </p>
        </div>
      </form>
    </div>
  </div>
</div>
